import child from '@/services/http/api/child'

export default {
  namespaced: true,
  state: {
    loader: null,
    child: null,
    paidAmount: null,
    childEditionRetentionHash: null
  },
  getters: {
    getChild: (state) => state.child,
    getLoader: (state) => state.loader,
    getPaidAmount: (state) => state.paidAmount,
    getChildEditionRetentionHash: (state) => state.childEditionRetentionHash
  },
  mutations: {
    setLoader(state, payload) {
      state.loader = payload
    },
    setChild(state, payload) {
      state.child = payload
    },
    setPaidAmount(state, payload) {
      state.paidAmount = payload
    },
    setChildEditionRetentionHash(state, payload) {
      state.childEditionRetentionHash = payload
    },
    clearChildEditionRetentionHash(state) {
      state.childEditionRetentionHash = null
    }
  },
  actions: {
    getChild(context, payload) {
      if (Number.isInteger(Number(payload.childId)) === false) {
        const error = new Error('invalid child edition id')
        error.response = { status: 404 }
        return Promise.reject(error)
      }
      context.commit('setLoader', true)
      if (payload.childEditionRetentionHash) {
        context.commit('setChildEditionRetentionHash', payload.childEditionRetentionHash)
      }
      return child
        .getChild(payload)
        .then(({ data }) => {
          const childData = data.data
          const { open_fundraising: openFundraising } = data.data

          if (data.data.payments_child_choice_path) {
            const paid =
              data.data.payments_child_choice_path.reduce((sum, el) => sum + el.amount, 0) || 0
            context.commit('setPaidAmount', paid)
            if (openFundraising === true) {
              childData.fundraising = {
                paid_amount: paid
              }
            }
          }

          context.commit('setChild', childData)
          context.commit('setLoader', false)
          return childData
        })
        .catch((err) => {
          if (err.response && err.response.status !== 403) {
            context.commit('setLoader', false)
          }
          throw err
        })
    }
  }
}
